module.exports = __webpack_public_path__ + "static/img/addresswhite.745ef96.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/addresswhite.png
// module id = 8qV2
// module chunks = 2